import React from 'react';
import { BookOpenIcon, CalendarHeartIcon, HandHeartIcon, HeartIcon, LayersIcon } from 'lucide-react';
import type { Bonus, BonusIcon } from '../data/content';
type BonusCoverProps = {
  bonus: Bonus;
  className?: string;
};
const icons: Record<BonusIcon, React.ComponentType<{
  className?: string;
}>> = {
  book: BookOpenIcon,
  prayer: HandHeartIcon,
  calendar: CalendarHeartIcon,
  heart: HeartIcon,
  cards: LayersIcon
};
export function BonusCover({
  bonus,
  className = ''
}: BonusCoverProps) {
  if (bonus.image) {
    return <img src={bonus.image} alt={`Portada de ${bonus.title}`} loading="lazy" className={`aspect-[3/4] w-full rounded-xl object-cover shadow-[0_18px_30px_-12px_rgba(104,69,54,0.45)] ${className}`} data-id="element-17" data-mp="3i0hed818h7yx" />;
  }
  const Icon = icons[bonus.icon];
  return <div role="img" aria-label={bonus.title} className={`flex aspect-[3/4] w-full flex-col items-center justify-center rounded-xl bg-cream p-3 text-center shadow-[0_18px_30px_-12px_rgba(104,69,54,0.35)] ${className}`} data-id="element-18" data-mp="21mrbu5prirre">
      <div className="flex h-full w-full flex-col items-center justify-center rounded-lg border border-gold/50 px-3" data-id="element-19" data-mp="2cc6uz9hpyis2">
        <Icon className="h-7 w-7 text-rose" aria-hidden="true" data-id="element-20" data-mp="2hbt87ixjrz0v" />
        <p className="mt-3 font-display text-lg font-semibold leading-tight text-brown" data-id="element-21" data-mp="2lcljsitw6g0b">{bonus.title}</p>
        <span aria-hidden="true" className="mt-3 h-px w-8 bg-gold/60" data-id="element-22" data-mp="2q3lhhqau523v" />
        <p className="mt-2 font-sans text-[0.55rem] font-semibold uppercase tracking-[0.18em] text-gold-deep" data-id="element-23" data-mp="2q4wm1sc3udw1">
          Mujer de Proverbios 31
        </p>
      </div>
    </div>;
}